/* HT fix 2026-07-28 (Claude): el panel de chat de Zoho SalesIQ (#zsiq_chat_wrap), cuando el cliente
   lo abre manualmente, ocupa una franja grande del lado derecho de la pantalla con z-index maximo
   (2147483647, el tope que soporta CSS) -- ningun elemento del tema puede quedar visualmente encima
   de el. Si el cliente abre el chat y despues intenta abrir el carrito (mini_cart_wrap, mismo lado
   derecho), el panel de chat le tapa el carrito y sus botones. Verificado en vivo: en una carga
   nueva de la pagina el chat arranca cerrado (0x0), asi que esto NO afecta a todos los visitantes --
   solo al que ya abrio el chat y despues toca el carrito sin cerrarlo primero. Este script no toca
   el widget de Zoho ni su script (cargado en layout/theme.liquid, fuera de nuestro control); solo
   escucha el click en los disparadores del carrito y, si el chat sigue abierto, lo cierra usando el
   propio boton de cierre de Zoho (#zs_fl_close) para que el carrito quede visible. */
(function () {
  'use strict';

  function closeSalesIQIfOpen() {
    var wrap = document.getElementById('zsiq_chat_wrap');
    if (wrap && wrap.className.indexOf('chat-iframe-open') !== -1) {
      var closeBtn = document.getElementById('zs_fl_close');
      if (closeBtn) closeBtn.click();
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.footer-mini-cart, .mini-cart, a[href="/cart"], [data-js-open-cart]') : null;
    if (trigger) {
      setTimeout(closeSalesIQIfOpen, 150);
    }
  }, true);
})();
